import EmailCapture from './EmailCapture';

function App() {
  return <EmailCapture />;
}

export default App;
